define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var lpAgent = require('web-agent-assets-js/lpAgent');

    window.lpTag = window.lpTag || {};
    lpTag.taglets = lpTag.taglets || {};

    var PollingManager = require('web-agent-utils/PollingManager');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');

    lpTag.lpChatController = function (model) {
        var chatsPollingManager = null;

        var chatController = {applicationType: "lpChatController"};

        var logger = WebAgentLogger.getLogger(chatController.applicationType);

        var chatModel = model;

        var SURVEY_NOT_FOUND_ERR_CODE = 12;

        // Model Methods
        chatController.getModelParam = function (paramName) {
            return chatModel.get(paramName);
        };
        chatController.bindModelParam = function (modelParam, func, scope, trigger) {
            chatModel.bind(modelParam, func, scope, trigger);
        };
        chatController.unbindModelParam = function (key, callback, context) {
            chatModel.unbind(key, callback, context);
        };
        // Decorator Methods
        chatController.addLine = function (object) {
            // Add unique id to the new agent line
            var rndId;
            rndId = "LPAgentLine" + new Date().getTime();
            object.verificationId = rndId;
            object.verified = false;

            var successFunc = object.success;
            var errorFunc = object.error;
            object.success = function (data) {
                object.verified = true;
                object.id = +data.id;
                chatModel.modify("chats." + object.chatId + ".newChatLine.lines", [object], 'id');
                if (successFunc) {
                    successFunc(data);
                }
            };
            object.error = function (data) {
                object.failed = true;
                object.errorData = lpUtils.cloneObject(data.error);
                chatModel.modify("chats." + object.chatId + ".newChatLine.lines", [object], 'id');
                if (errorFunc) {
                    errorFunc(data);
                }
            };
            lpAgent.chat.addLine(object);

            //Write line to data model so it will print it to the agent.
            chatModel.modify("chats." + object.chatId + ".newChatLine.lines", [object]);
            if (object.text === "") { // if the text is empty here its because it was all malicious and therefor sanitized
                return;
            }
        };
        chatController.endChat = function (object) {
            logger.info("", "endChat", object);
            return lpAgent.chat.endChat(object);
        };
        chatController.setAgentTyping = function (object) {
            return lpAgent.chat.setAgentTyping(object);
        };
        chatController.getAgentSurvey = function (object) {
            logger.info({chatId: object.chatId}, "getAgentSurvey");
            return lpAgent.chat.getAgentSurvey(object);
        };
        chatController.setAgentSurvey = function (object) {
            logger.info({chatId: object.chatId}, "setAgentSurvey");
            return lpAgent.chat.setAgentSurvey(object);
        };
        chatController.startSpectate = function (object) {
            logger.info({chatId: object.chatId}, "startSpectate");
            if (!chatsPollingManager) {
                chatsPollingManager = new PollingManager({
                    key: 'chatId',
                    startCallback: lpAgent.chat.startSpectate,
                    pauseCallback: lpAgent.chat.pauseSpectate,
                    resumeCallback: lpAgent.chat.resumeSpectate,
                    stopCallback: lpAgent.chat.stopSpectate,
                    pollingContext: lpAgent.chat,
                    removeDataCallback: lpTag.WebAgent.chatController.removeSpectateFromModel,
                    dataContext: lpTag.WebAgent.chatController
                });
            }
            chatsPollingManager.setActiveItem(object);
        };
        chatController.stopSpectate = function (object) {
            logger.info({chatId: object.chatId}, "stopSpectate");
            if (chatsPollingManager) {
                chatsPollingManager.setInactiveItem(object);
            }
        };
        chatController.removeSpectateFromModel = function (object) {
            logger.info({chatId: object.chatId}, "removeSpectateFromModel");
            //remove this chat from web agent model
            chatModel.removeKey("chats." + object.chatId);
        };
        chatController.openEngagement = function (object) {
            logger.info({chatId: object.chatId}, "openEngagement");
            var chatData = chatModel.get("chats." + object.chatId);
            lpAgent.chat.openSpectated({
                chatId: chatData.chatInfo.chatId,
                visitorId: chatData.visitorInfo.visitorId,
                shark: chatData.visitorInfo.shark
            });
            handleNewVisitor(chatData);
            addParticipantToModel(chatData);
        };

        function init() {
            if (lpAgent.chat) {
                // Register on chat callbacks
                for (var key in lpAgent.chat) {
                    if (lpAgent.chat.hasOwnProperty(key) && String(key).indexOf('on') === 0) {
                        switch (key) {
                            case    "onChatEvents":
                                lpAgent.chat[key](handleChatEvents);
                                break; // TODO: Events should be handled generically.
                            case    "onChatLine":
                                lpAgent.chat[key](handleChatLine);
                                break; // TODO: Events should be handled generically.
                            case    "onChatInfo":
                                lpAgent.chat[key](handleChatInfo);
                                break;
                            case    "onChatState":
                                lpAgent.chat[key](handleChatState);
                                break;
                            case    "onSetAgentTyping":
                                lpAgent.chat[key](handleSetAgentTyping);
                                break;
                            case    "onEndChat":
                                lpAgent.chat[key](handleEndChat);
                                break;
                            case    "onAgentSurvey":
                                lpAgent.chat[key](handleAgentSurvey);
                                break;
                            case    "onSetAgentSurvey":
                                lpAgent.chat[key](handleSetAgentSurvey);
                                break;
                            case    "onAddLine":
                                lpAgent.chat[key](handleAddLine);
                                break;
                            case    "onStartSpectate":
                                lpAgent.chat[key](handleSpectate);
                                break;
                            default:
                                lpAgent.chat[key](updateModel);
                        }
                    }
                }
            } else {
                setTimeout(init, 500);
            }
        }

        function updateModel(data) {
            chatModel.modify("chat", data);
        }

        function handleChatEvents(data) {
            if (data.chatInfo) {
                updateEventsInModel();
                handleEventByGroups();
            }
            data = null;

            function handleEventByGroups() {
                var eventsGroups = getEventsByGroups();
                if (eventsGroups) {
                    for (var key in eventsGroups) {
                        if (eventsGroups.hasOwnProperty(key)) {
                            switch (key) {
                                case 'line':
                                    updateChatLines(eventsGroups[key]);
                                    break;
                                case 'state':
                                    updateChatState(eventsGroups[key]);
                                    break;
                                case 'leCollaboration':
                                    break;
                                default:
                                    logger.warn('Unhandled event type', key);
                                    break;
                            }
                        }
                    }
                }

            }

            function updateChatLines(events) {
                cleanArray(events);

                // update the chats line in the model
                chatModel.modify('participants.info.' + data.visitorInfo.visitorId + '.data.currentChat.lines', events, 'time');
            }

            function updateChatState(events) {
                var lastState = events[events.length - 1].state;
                chatModel.modify('participants.info.' + data.visitorInfo.visitorId + '.data.currentChatState', lastState);
            }

            function updateEventsInModel() {
                var uniqueArrayId = data.chatInfo.events.event[0].id ? 'id' : '@id';
                chatModel.modify('chats.' + data.chatInfo.chatId + '.chatInfo.events', data.chatInfo.events, uniqueArrayId);
                chatModel.modify('chats.' + data.chatInfo.chatId + '.chatInfo.lastUpdate', data.chatInfo.lastUpdate);
            }

            function getEventsByGroups() {
                return lpUtils.cloneObject(_.groupBy(data.chatInfo.events.event, function (item) {
                    return item.type || item['@type'];
                }));
            }

            /**
             * this function will arrange the array items object to be in one structure the id property always  be 'id' (not @id) and the 'type' property always be 'type' (not @type)
             * @param {data} should by array
             */
            function cleanArray(data) {
                if (data) {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].hasOwnProperty('@type')) {
                            data[i].type = data[i]['@type'];
                            delete data[i]['@type'];
                        }
                        if (data[i].hasOwnProperty('@id')) {
                            data[i].id = data[i]['@id'] + '';  //we want to make sure that the id always be string
                            delete data[i]['@id'];
                        }
                    }
                }
            }
        }

        function handleChatLine(data) {
            chatModel.modify("chats." + data.chatId + ".newChatLine.lines", data.lines);
            data = null;
        }

        function handleChatInfo(data) {
            var chatId = data.chatInfo.chatId;
            chatModel.modify("chats." + chatId, data);
            data = null;
        }

        function handleChatState(data) {
            if (data.error) {
                logger.error("", "handleChatState", data);
                logger.graph({name: 'handleChatStateError'});
            } else {
                var chatInfo = {};
                if (data.state) {
                    chatInfo.state = data.state;
                    if (data.state == "ended" || data.state == "transferred") {
                        logger.info("", "handleChatState", data);
                        if (data.time) { // This is for calculations on the chat duration
                            chatInfo.endTime = data.time;
                        } else {
                            logger.error("chat state returned null for [data.time] from server", "handleChatState");
                            logger.graph({name: 'chatStateNullError'});
                        }
                    }
                    // If we receive updates on the chat's state - the chat is active.
                    // This means we shouldn't keep it in the polling manager
                    if (chatsPollingManager) {
                        chatsPollingManager.removeItemById(data.chatId);
                    }
                }
                chatModel.modify("chats." + data.chatId + ".chatInfo", chatInfo);
                chatInfo = null;
            }
            data = null;
        }

        function handleSetAgentTyping(data) {
            if (data.error) {
                logger.error("", "handleSetAgentTyping", data);
                logger.graph({name: 'handleSetAgentTypingError'});
            } else {
                logger.info("", "handleSetAgentTyping", data);
                chatModel.modify("chats." + data.chatId + ".agentInfo.agentTyping", data.typing);
            }
            data = null;
        }

        function handleEndChat(data) {
            if (data.error) {
                logger.error("", "handleEndChat", data);
                logger.graph({name: 'handleEndChatError'});
            } else {
                logger.info("", "handleEndChat", data);
                data.endTime = data.time;
                chatModel.modify("chats." + data.chatId + ".chatInfo", data);
            }
        }

        function handleAgentSurvey(data) {
            if (data.error) {
                if(data.error.internalCode !== SURVEY_NOT_FOUND_ERR_CODE) {
                    logger.error("", "handleAgentSurvey", data);
                    logger.graph({name: 'handleAgentSurveyError'});
                }
            } else {
                chatModel.modify("chats." + data.chatId + ".agentSurvey", data);
                var logData = {chatId: data.chatId, surveyState: data.survey.surveyState};
                logger.info("", "handleAgentSurvey", logData);
            }
            data = null;
        }

        function handleSetAgentSurvey(data) {
            if (data.error) {
                logger.error("", "handleSetAgentSurvey", data);
                logger.graph({name: 'handleSetAgentSurveyError'});
            } else {
                logger.info("", "handleSetAgentSurvey", data);
                model.modify("chats." + data.chatId + ".agentSurvey.survey.surveyState", "Filled");
            }
        }

        function handleAddLine(data) {
            // do nothing for now since we enter the agent chat line manually, later we can validate here that latest entered lines are actually getting to the app server
        }

        function handleSpectate(data) {
            if (data.error) {
                logger.error("", "handleSpectate", data);
                logger.graph({name: 'handleSpectateError'});
            } else {
                logger.info("", "handleSpectate", data);
            }
        }

        function addParticipantToModel(chatData) {
            var visitorObject = {
                participantInfo: chatData.visitorInfo,
                chats: {},
                participantTag: ''
            };
            visitorObject.chats[chatData.chatInfo.chatId] = chatData.chatInfo.chatId;
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(chatData.visitorInfo.visitorId);
            chatModel.modify(participantPath, visitorObject);
        }

        function handleNewVisitor(data) {
            if (data.visitorInfo && data.visitorInfo.visitorId) {
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(data.visitorInfo.visitorId);
                if (chatController.getModelParam(participantPath) == null) {
                    data.visitorInfo.engagementStartTime = data.chatInfo.startTime;
                }
                // setting the accepted/spectated flags so that the listeners will be called for every new chat
                data.visitorInfo.spectatedEngagement = true;
                data.visitorInfo.acceptedEngagement = false;
            }
        }

        init();
        return chatController;
    };

    return lpTag.lpChatController;

});
